import React from "react";
import ContentEditable from 'react-contenteditable';
import PropTypes from 'prop-types';

class TextChange extends React.Component{
    constructor(props){
        super(props);
        this.contentEditable = React.createRef();
        this.state = {
            Text : this.props.Text.replaceAll('Set all','Set all55555'),
        };
        this.handleChange = this.handleChange.bind(this);
        this.BlurChange = this.BlurChange.bind(this);
    };

    handleChange = event => {this.setState({ Text: event.target.value});};
    BlurChange = () => {this.props.update(this.state.Text,this.props.ArrIndex,this.props.lang);};

    render() {
        // console.log('7777',this.props.Text);

        if (this.props.Adminka){
            return (
                <ContentEditable
                    innerRef={this.contentEditable}
                    html={this.state.Text.replaceAll('<','gt;')} // innerHTML of the editable div
                    disabled={false}       // use true to disable editing
                    onChange={this.handleChange} // handle innerHTML change
                    onBlur = {this.BlurChange}
                    tagName='div' // Use a custom HTML tag (uses a div by default)
                />
            )}
        else {
            // return <React.Fragment>{this.state.Text ? parse(this.state.Text) : this.props.TextDefault}</React.Fragment>
            return <React.Fragment>{this.state.Text}</React.Fragment>
        }
    }

}

export default TextChange

TextChange.propTypes = {
    Text: PropTypes.string,
    TextDefault: PropTypes.string,
    ArrIndex: PropTypes.string,
    handleChange: PropTypes.func,
    Adminka: PropTypes.bool
};